import Vue from 'vue';
import Router from 'vue-router';
import Map from './pages/Map';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import CookiePolicy from './pages/CookiePolicy';
Vue.use(Router);

export default new Router({
  base: '/niico/',
  routes: [
    {
      path: '/',
      component: Map,
      name: 'root'
    },
    {
      path: '/:lang',
      component: Map,
      name: 'map'
    },
    {
      path: '/news',
      component: News,
      name: 'news'
    },
    {
      path: '/news/:no',
      component: NewsDetail,
      name: 'newsdetail'
    },
    {
      path: '/cookie-policy',
      component: CookiePolicy,
      name: 'cookiepolicy'
    },
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});
